import React, { Component } from 'react';

import * as routes from '../../config/routes';
import { auth } from '../../firebase';


const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  error: null,
};

export default class ForgotPasswordPage extends Component {
  
  onSubmit = (event) => {
    const { email } = this.state;

    auth.doPasswordReset(email)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      error,
    } = this.state;

    return (
    	<div id="page-content">
	    <div className="page-fullscreen">
	        <div className="page-fullscreen-content">
	            <div className="pageapp-login">
	                <a className="page-logo"></a>
	              
                  
	                <div className="pageapp-login-input">
	                    <i className="login-icon ion-at"></i>
	                    <input type="text" value={email}
				          onChange={event => this.setState(byPropKey('email', event.target.value))}
				          type="text"
				          placeholder="Email Address" />
	                </div>                     

			        { error && <p>{error.message}</p> }
	                <a onClick={this.onSubmit} className="button button-green button-icon button-full half-top half-bottom"><i className="ion-log-in"></i>Reset Password</a>

	                <a href={routes.SIGN_UP} className="button button-blue button-icon button-full half-top full-bottom"><i className="ion-person"></i>Create An Account</a>
	            </div>
	        </div>
	        <div className="overlay dark-overlay"></div>
	    </div> 
	    </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/identity/ForgotPassword.js